<template>
  <div>
    <PatientList
      :patients="patients"
      :totalDocs="totalDocs"
      :page="page"
      @fetchList="getPatientsList"
      @viewPatientDetail="patientDetail"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PatientList from '../../components/patients/List';

export default {
  components: {
    PatientList,
  },
  data() {
    return {
      totalDocs: 0,
      page: 1,
      patients: [],
    };
  },
  methods: {
    ...mapActions('patient', ['fetchFranchisePatient']),
    async getPatientsList(dataTableParams) {
      let self = this;
      this.fetchFranchisePatient(dataTableParams).then(res => {
        self.patients = res.data.data.docs;
        self.totalDocs = res.data.data.pagination.total || 0;
        self.page = res.data.data.pagination.page;
        self.currentPage = res.data.data.pagination.page;
      });
    },
    patientDetail(id) {
      this.$router.push({
        name: 'ClinicPatientDetail',
        params: { patientId: id },
      });
    },
  },
};
</script>
